import posthog from "posthog-js";
import { CUSTOM_STORE, REACT_APP_ACCESS_KEY, REACT_APP_FITVIEW_CLIENT_URL, REACT_APP_SWAN_API_SERVER_URL, STORAGE_KEY } from "../services/constant";
import TryonText from "../component/tryonText/TryonText";
import RecomendationText from "../component/recomendationText/RecomendationText";
import DefaultText from "../component/defaultText/DefaultText";
import HOC from "../component/hoc/HOC";
import UseApiService from "../services/apiService";
import CustomMeasurementText from "../component/cutomMeasurementText/CustomMeasurementText";
import {jwtDecode} from 'jwt-decode';

export function getURLSearchParamsValue(url) {
	return new URLSearchParams(url);
}

export function setLocalStorage(key, value) {
	localStorage.setItem(key, value);
}

export function getLocalStorage(key) {
	return localStorage.getItem(key);
}
export function removeLocalStorage(key) {
	localStorage.removeItem(key);
}

export function getElementById(id) {
	return document.getElementById(id);
}

export async function userVerify(swanApiServerURL, token) {
	try {
		const res = await UseApiService.post({ url: `${swanApiServerURL}/auth/verify?token=${token}` });
		setLocalStorage("JWTToken", res?.data?.token);
	} catch (error) {
		console.log(error);
	}
}

export const getEndpointProductSupportBySwan = ({ productHandle, shopDomain }) => `${REACT_APP_SWAN_API_SERVER_URL}/customers/${shopDomain}/products/${productHandle}`;

export const getEndpointRecommendation = ({ productHandle, scanID, shopDomain }) => `${REACT_APP_SWAN_API_SERVER_URL}/recommendation/scan/${scanID}/shop/${shopDomain}/product/${productHandle}`;

export const getEndpointFitViewScan = ({ productHandle, shopDomain, shopifyRedirectUrl,callbackUrl }) =>{
	let url = `${REACT_APP_FITVIEW_CLIENT_URL}?shop_domain=${shopDomain}&product_name=${productHandle}&shopify_redirect=${shopifyRedirectUrl}`;
	if(callbackUrl){
		url+=`&callback_url=${callbackUrl}`
	  }
	return url;
}

export const getEndpointFitViewResult = ({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email }) =>
	`${REACT_APP_FITVIEW_CLIENT_URL}/fit-view?shop_domain=${shopDomain}&product_name=${productHandle}&shopify_redirect=${shopifyRedirectUrl}&scan_id=${scanID}&email=${encodeURIComponent(email)}`;

const getEndpointFitViewCustomReScan = ({productHandle,shopDomain,shopifyRedirectUrl,email,name,scanID,callbackUrl}) => {
	let url = `${REACT_APP_FITVIEW_CLIENT_URL}/rescan?shop_domain=${shopDomain}&product_name=${productHandle}&shopify_redirect=${shopifyRedirectUrl}&scan_type=clothing_custom_scan&scan_id=${scanID}`;
	if (email) {
	  url += `&email=${encodeURIComponent(email)}`;
	}
	if(name){
	  url+=`&name=${name}`
	}
	if(callbackUrl){
		url+=`&callback_url=${callbackUrl}`
	  }
	return url;
  };
  export const getEndpointFitViewCustomScan = ({productHandle,shopDomain,shopifyRedirectUrl,email,name,callbackUrl}) => {
	let url = `${REACT_APP_FITVIEW_CLIENT_URL}?shop_domain=${shopDomain}&product_name=${productHandle}&shopify_redirect=${shopifyRedirectUrl}&scan_type=clothing_custom_scan`;
	if (email) {
	  url += `&email=${encodeURIComponent(email)}`;
	}
	if(name){
	  url+=`&name=${name}`
	}
	if(callbackUrl){
		url+=`&callback_url=${callbackUrl}`
	  }
	return url;
  };
export async function checkTryOnAvailable({ email, shopDomain, productHandle }) {
	if (!email || email === "null") return false;
	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/tryon/status`,
			params: {
				customerStoreUrl: shopDomain,
				productName: productHandle,
				userEmail: encodeURIComponent(email),
			},
		};
		const res = await UseApiService.get(body);
		const isAvailable = res?.data.tryonExists === true && res?.data.tryonStatus === "available";
		const status = isAvailable ? "success" : "failed";
		handleScanTimeCapture({ message: `${shopDomain}/try-on/shopify`, status, email });
		return isAvailable;
	} catch (error) {
		console.error(error, "while checking try-on availability");
		handleScanTimeCapture({ message: `${shopDomain}/try-on/shopify`, status: "failed", email });
		return false;
	}
}

export async function handleShowTryOn({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email }) {
	if (!email || email === "null") {
		throw new Error("Email does not exist, setting up new Try-On");
	}
	return generateTryOnLink({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
}

export function generateTryOnLink({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email }) {
	const fitViewResultEndpoint = getEndpointFitViewResult({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
	return { text: <TryonText />, links: fitViewResultEndpoint };
}

export async function handleShowSize({ productHandle, scanID, shopDomain, isOnboadedTryon, shopifyRedirectUrl, email, setUpcallBack }) {
	if (!scanID || scanID === "null") {
		throw new Error("scanID does not exist, setting up new scan");
	}
	try {
		const sizeRecommendation = await fetchRecommendation({ productHandle, shopDomain, scanID, setUpcallBack });
		if (!sizeRecommendation) {
			throw new Error("Unable to fetch recommendation, setting up new scan");
		}
		return getScansizingDisplay({
			productHandle,
			sizeRecommendation,
			isOnboadedTryon,
			shopDomain,
			shopifyRedirectUrl,
			scanID,
			email,
		});
	} catch (error) {
		throw error;
	}
}

export async function fetchRecommendation({ productHandle, shopDomain, scanID, setUpcallBack }) {
	const endpoint = getEndpointRecommendation({ productHandle, scanID, shopDomain });
	try {
		const result = await UseApiService.get({ url: endpoint });
		handleScanTimeCapture({
			message: `${shopDomain}/measurement_success/shopify`,
			scanId: scanID,
			status: "success",
		});
		return result?.data?.size_recommendation;
	} catch (error) {
		console.error(error, "error");
		handleScanTimeCapture({
			message: `${shopDomain}/measurement_failed/shopify`,
			scanId: scanID,
			status: "failed",
		});
		removeLocalStorage(STORAGE_KEY.SCAN_ID);
		setUpcallBack();
	}
}

export function getScansizingDisplay({ productHandle, sizeRecommendation, isOnboadedTryon, shopDomain, shopifyRedirectUrl, scanID, email }) {
	const recommendedSize = sizeRecommendation?.ideal?.size || "N/A";
	const fitViewResultEndpoint = getEndpointFitViewResult({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
	return { text: <RecomendationText recommendedSize={recommendedSize} isOnboadedTryon={isOnboadedTryon} />, links: fitViewResultEndpoint };
}

export async function setupCTADisplay({ productHandle, isOnboadedTryon = false, isOnboadedRTW = false, email, shopDomain, shopifyRedirectUrl, scanID, setUpcallBack, handleInnerText, isCustom,name,callbackUrl }) {
	let result = <DefaultText isOnboadedTryon={isOnboadedTryon} />;
	let defaultApi = true;
	let link;
	
	if (isCustom) {
		await handleCustomBtn({scanID,shopDomain,productHandle,handleInnerText,result,shopifyRedirectUrl,email,name,callbackUrl})
		return;
	}
	console.log(`isOnboadedRTW:${isOnboadedRTW},isOnboadedTryon:${isOnboadedTryon}, checking onboarded`);
	if (isOnboadedTryon && isOnboadedRTW) {
		let res = false;
		let scanRes = false;
		try {
			res = await checkTryOnAvailable({ email, shopDomain, productHandle });
			if (res) {
				result = await handleShowTryOn({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
				defaultApi = false;
			}
		} catch (error) {
			console.log(error);
			defaultApi = true;
		}
		try {
			scanRes = await handleShowSize({
				productHandle,
				scanID,
				shopDomain,
				isOnboadedTryon,
				shopifyRedirectUrl,
				email,
				setUpcallBack,
			});
			result = scanRes;
			defaultApi = false;
			res = false;
		} catch (error) {
			console.log(error);
			defaultApi = true;
		} finally {
			if ((res || email) && !scanRes) {
				link = getEndpointFitViewResult({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
				defaultApi = false;
			}
		}
	} else if (isOnboadedTryon && !isOnboadedRTW) {
		try {
			const res = await checkTryOnAvailable({ email, shopDomain, productHandle });
			if (res) {
				result = await handleShowTryOn({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
				defaultApi = false;
			} else {
				if (email) {
					link = getEndpointFitViewResult({ productHandle, shopDomain, shopifyRedirectUrl, scanID, email });
					defaultApi = false;
				}
			}
		} catch (error) {
			console.log(error);
			defaultApi = true;
		}
	} else if (!isOnboadedTryon && isOnboadedRTW) {
		try {
			result = await handleShowSize({
				productHandle,
				scanID,
				shopDomain,
				isOnboadedTryon,
				shopifyRedirectUrl,
				email,
				setUpcallBack,
			});
			defaultApi = false;
		} catch (error) {
			console.log(error);
			defaultApi = true;
		}
	}
	const text = <HOC>{result?.text??result}</HOC>;
	handleInnerText(text, defaultApi, result?.links ?? link);
}

export function handleScanTimeCapture({ message, scanId, status, email }) {
	const timestamp = new Date().toISOString();
	let obj = {
		status,
		timestamp,
		email,
	};
	if (scanId) {
		obj = { ...obj, scanID: scanId };
	}
	posthog?.capture(message, obj);
}

export const handleCustomBtn=async ({scanID,shopDomain,productHandle,handleInnerText,result,email,name,shopifyRedirectUrl,callbackUrl})=>{
	let error =false
	try {
		result = await checkCustomMeasurements({productHandle,shopDomain,shopifyRedirectUrl,email,name,scanID,callbackUrl});
	} catch (err) {
		console.log(err);
        error = true
	}
	 const text = <HOC>{result?.text??result}</HOC>
	 handleInnerText(text,error,result?.link ??getEndpointFitViewCustomScan({ productHandle, shopDomain, shopifyRedirectUrl, email, name,callbackUrl }) )
	return;
}

export const storeSubscriptionCheck = async (storeName) => {
	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/shopify/subscription`,
			params: {
				store_url: storeName,
			},
		};
		const res = await UseApiService.get(body);
		const { data } = res;
		if (data?.isTrialDemo) {
			return true;
		} else if (data?.isValid) {
			return data?.hasCustomAddon;
		}
		throw new Error("Store not subscribed");
	} catch (error) {
		throw new Error(error);
	}
};
async function checkCustomMeasurements({productHandle,shopDomain,shopifyRedirectUrl,email,name,scanID,callbackUrl}) {
	if (scanID === "null" || !scanID) {
		throw new Error("scan Id not found ");
	}
	try {
		const body = {
			url: `${REACT_APP_SWAN_API_SERVER_URL}/measurements`,
			params: {
				scanId: scanID,
			},
		};
		const res = await UseApiService.get(body);
		if (res?.data?.isMeasured) {
			if ([CUSTOM_STORE.HOUSE_OF_ALDENO, CUSTOM_STORE.SWAN_CUSTOM_STORE_STAGING].includes(shopDomain)) {
			  return {text:<CustomMeasurementText/>,link:getEndpointFitViewCustomReScan({productHandle,shopDomain,shopifyRedirectUrl,email,name,scanID,callbackUrl})}
			}else{
			getElementById("swan-btn-parent-div").style.cursor="default"
			getElementById("swan-btn-parent-div").addEventListener('click', (e) => {
				e.stopPropagation();
			  })
			}
			return <CustomMeasurementText/>;
		}
		throw new Error("No custom measurements found");
	} catch (error) {
		throw new Error(error);
	}
	
	
}
export const  checkTokenValidity=(token, userEmail)=> {
  try {
    const payload = jwtDecode(token);
    const { exp, email } = payload;
    const currentTime = Math.floor(Date.now() / 1000);
    if (!exp || currentTime > exp) {
      console.log('Token has expired.');
      return false;
    }
    if (!email || email !== userEmail) {
      console.log('User email mismatch.');
      return false;
    }
    return true;
  } catch (error) {
    console.error('Invalid token:', error.message);
    return false;
  }
}

export function clearLocalStorage() {
	removeLocalStorage(STORAGE_KEY.EMAIL);
	removeLocalStorage(STORAGE_KEY.JWTToken);
	removeLocalStorage(STORAGE_KEY.SCAN_ID);
  }

 export async function getUserDetails(userEmail) {
	try {
	  const res = await UseApiService.get({url:`${REACT_APP_SWAN_API_SERVER_URL}/user/${userEmail}`});
		const data = res.data;
		if (data?.has_measurement) {
		  setLocalStorage(STORAGE_KEY.SCAN_ID, data?.latest_scan_id);
		}
	} catch (error) {
		if (error.response.status === 404) {
		  removeLocalStorage(STORAGE_KEY.SCAN_ID);
		} 
	  console.log(error, 'error while getting user details');
	}
  }

  export async function silentLogin({email, userName,shopDomain}) {  
	try {
		const body={
			url:`${REACT_APP_SWAN_API_SERVER_URL}/auth/silent`,
			data:{
				email,
				userName,
				context: { shop_domain: shopDomain },
			  },
			  headers: {
				'X-Api-Key': REACT_APP_ACCESS_KEY,
			  }
		}
	  const res = await UseApiService.post(body);
		const data = res.data;
		if (data?.magicLinkToken) {
		  setLocalStorage(STORAGE_KEY.EMAIL, email);
		  setLocalStorage(STORAGE_KEY.JWTToken, data.magicLinkToken);
		  await getUserDetails(email);
		} else {
		  throw new Error('Missing magicLinkToken in response');
		}
	} catch (error) {
	  console.log(error, 'while silent login');
	  localStorage.clear(); // Clear local storage in case of error
	}
  }
  